import { yup } from "@swa-ui/object";

export const ANIMAL_ASSISTANCE_SCHEMA_FIELD_NAME = "passengerDisabilityAssistanceAnimal";

export const getAnimalAssistanceFormFieldSchema = (fieldNames = {}) => {
  const { serviceAnimal = ANIMAL_ASSISTANCE_SCHEMA_FIELD_NAME } = fieldNames;

  return {
    [serviceAnimal]: yup.boolean(),
  };
};
